import { useCallback, useEffect, useRef, useState } from "react";
import AutocompleteFetchInput from "../../../javascript/presentation/components/inputs/autocomplete-fetch-input";
import { getProjects } from "../../../javascript/api/projects";
import { toOptions } from "../../../javascript/helpers/helpers";

const ProjectsFilter = ({ onChange, accountId, clearFilter, selectedIds = [] }) => {
    const [selectedProjectOptions, setSelectedProjectOptions] = useState(selectedIds.map((id) => ({ value: id, label: 'Carregando...' })));
    const initializedIds = useRef([]);

    const handleProjectsChange = (data) => {
        const newIds = data.map((project) => project.value);

        initializedIds.current = newIds;

        setSelectedProjectOptions(data);
        onChange(newIds);
    };

    useEffect(() => {
        if (clearFilter) {
            setSelectedProjectOptions([]);
            initializedIds.current = [];
        }
    }, [clearFilter]);

    const fetchProjects = useCallback(async (q = "") => {
        try {
            const result = await getProjects({ accountId, q });
            return toOptions(result.results);
        } catch (err) {
            console.error(err);
            return [];
        }
    }, [accountId]);

    useEffect(() => {
        if (
            !selectedIds.length || JSON.stringify(initializedIds.current) === JSON.stringify(selectedIds)
        ) {
            return;
        }

        initializedIds.current = [...selectedIds];

        getProjects({ accountId, ids: selectedIds })
            .then((result) => setSelectedProjectOptions(toOptions(result.results)))
            .catch(console.error);
    }, [accountId, selectedIds]);

    return (
        <AutocompleteFetchInput
            label="Projetos"
            value={selectedProjectOptions}
            setValue={handleProjectsChange}
            fetchOptions={fetchProjects}
        />
    );
}

export default ProjectsFilter;